import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export const LineReveal = ({ lines, className = "", delay = 0, immediate = false, lineClassName = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-5% 0px" });
  const show = immediate || inView;
  return (
    <span ref={ref} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={show ? { y: 0 } : {}}
            transition={{ duration: 1.1, delay: show ? delay + i * 0.14 : 0, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const Reveal = ({ children, className = "", delay = 0, clip = false, style, ...rest }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-5% 0px" });
  const hidden = clip ? { clipPath: "inset(0 0 100% 0)" } : { opacity: 0, y: 40 };
  const shown = clip ? { clipPath: "inset(0 0 0% 0)" } : { opacity: 1, y: 0 };
  return (
    <motion.div
      ref={ref}
      style={style}
      className={className}
      initial={hidden}
      animate={inView ? shown : {}}
      transition={{ duration: 1.1, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};
